import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Checkbox, CircularProgress } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { base64File } from "../../../method/fineBase64file/finebase64file";
import ModalContarct from './contractModal/contractModal';
import ModalSuccess from './successModal/successModal';
import { select_online_contarct_api } from "../../../../redux/register/contarct/selectOnlineContarct/selectOnlineContarct";
import { notificationAlertErrorApi } from '../../../method/notificationAlertErrorApi/notificationAlertErrorApi'
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

let useStyles = makeStyles(() => ({
    root: {
        width: 1198,
        maxWidth: '95%',
        padding: 64,
        borderRadius: 32,
        backgroundColor: '#ffffff',
        boxShadow: " 0px 2px 15px 0px #0000000D",
        margin: 'auto',
        "@media(max-width : 700px)": {
            padding: '32px',
        },
        "@media(max-width : 500px)": {
            padding: '32px 16px',
        },

    },
    gridTilte: {
        marginBottom: 32
    },

    textHelp: {
        color: "#ADADAD",
        fontSize: 18,

    },
    text: {
        marginBottom:0

    },
    gridContract: {
        minHeight: 442,
        border: '1px solid rgba(0,0,0,0.1)'
    },
    loading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    gridFooter: {
        minWidth: 290,
        display: 'flex',
        alignItems: 'center',
        borderRadius: 4,
        marginTop: 20,
        marginBottom: 5,

    },
    checkBoxContract: {
        marginLeft: 10,
        padding: '0px  0px 0px 10px !important',
        '&.Mui-checked': {
            color: '#0B1742 !important',
        },
    },
}))




const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const Index = () => {

    let classes = useStyles();
    const location = useLocation();
    const formikRef = useRef();
    let dispatch = useDispatch();
    const history = useHistory();

    const [loading, setLoading] = useState(false)
    const [open, SetOpen] = useState(false)
    const [flagSuccessRegister, SetFlagSuccessRegister] = useState(false)
    const [contract, setContract] = useState(null)

    const { token, national_id, servics } = location?.state?.state || location?.state || {};

    const apiGetUserOnlineContarct = () => {

        let payload = {
            data: {
                NationalCode: national_id,
            },
            headers: {
                token: token
            }
        }

        setLoading(true)

        select_online_contarct_api(payload)
            .then((res) => {
                let data = res?.data?.data?.contractFile || null
                if (data) {
                    setContract(
                        base64File(data)
                    )
                }
            })
            .catch((error) => {
                notificationAlertErrorApi(error, dispatch)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    useEffect(() => {
        if (!national_id || !token) {
            alert('کاربر گرامی شما دسترسی به این صفحه را ندارید')
            history.push('/register/national', {
                national_id: national_id,
                servics: "servics"
            });
            return
        }
        apiGetUserOnlineContarct()
    }, [national_id])



    return (
        <div style={{ width: '100%' }}>
            <div className={classes['root']}>
                <div className={classes['gridTilte']}>
                    <p>
                        <span className={classes['textHelp']}>
                            قراردادها
                        </span>
                    </p>
                    <p >
                        لطفا جهت ادامه ی فرآیند  قرارداد را مطالعه فرمایید:
                    </p>
                </div>
                <div className={`${classes['gridContract']} ${classes['loading']}`}>
                    {
                        loading
                            ? <CircularProgress />
                            : contract
                                ? <iframe
                                    src={contract}
                                    width="100%"
                                    height="600px"
                                />
                                : 'داده ای یافت نشد'
                    }
                </div>

                <div className={classes['gridFooter']}>
                    <Checkbox
                        {...label}
                        className={classes['checkBoxContract']}
                        checked={open}
                        onChange={(event) => SetOpen(event?.target?.checked)}
                    />
                    <p className={classes['text']}>
                        تمامی بندهای قراردادها و توافق‌نامه‌ها را مطالعه نموده و آن را می‌پذیرم.
                        <span style={{ color: 'red' }}>
                            *
                        </span>
                    </p>
                </div>
                <ModalContarct
                    open={open}
                    openSuccess={SetFlagSuccessRegister}
                    onClose={() => SetOpen(false)}
                />

                <ModalSuccess
                    open={flagSuccessRegister}
                    onClose={() => SetFlagSuccessRegister(false)}
                />
            </div>
        </div>
    )
}

export default Index                          